'use strict';

import { Entity } from '../Entity';

export class AgencyPersonalToken extends Entity {
  protected id;

  protected app;

  protected agency;

  protected accessToken;

  protected dateTimeCreated;

  protected name;

  protected external;

  protected username;

  protected password;

  protected accountId;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.app = data.app;

    this.agency = data.agency;

    this.accessToken = data.accessToken;

    this.dateTimeCreated = data.dateTimeCreated;

    this.name = data.name;

    this.external = data.external;

    this.username = data.username;

    this.password = data.password;

    this.accountId = data.accountId;
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getApp() {
    return this.app;
  }

  public setApp(app) {
    this.app = app;

    return this;
  }

  public getAgency() {
    return this.agency;
  }

  public setAgency(agency) {
    this.agency = agency;

    return this;
  }

  public getAccessToken() {
    return this.accessToken;
  }

  public setAccessToken(accessToken) {
    this.accessToken = accessToken;

    return this;
  }

  public getDateTimeCreated() {
    return this.dateTimeCreated;
  }

  public setDateTimeCreated(dateTimeCreated) {
    this.dateTimeCreated = dateTimeCreated;

    return this;
  }

  public getName() {
    return this.name;
  }

  public setName(name) {
    this.name = name;

    return this;
  }

  public getExternal() {
    return this.external;
  }

  public setExternal(external) {
    this.external = external;

    return this;
  }

  public getUsername() {
    return this.username;
  }

  public setUsername(username) {
    this.username = username;

    return this;
  }

  public getPassword() {
    return this.password;
  }

  public setPassword(password) {
    this.password = password;

    return this;
  }

  public getAccountId() {
    return this.accountId;
  }

  public setAccountId(accountId) {
    this.accountId = accountId;

    return this;
  }
}
